// components/compliance/PHIWarningBanner.jsx
import React from "react";

/**
 * HIPAA PHI Warning Banner
 * Displays a warning that the page contains Protected Health Information
 * and that access is logged for compliance.
 */
const PHIWarningBanner = () => {
  return (
    <div className="alert alert-warning mb-3">
      <h6 className="alert-heading">
        <i className="bi bi-shield-lock-fill"></i> Protected Health Information
        (PHI)
      </h6>
      <small>
        This page contains Protected Health Information. Access is logged and
        monitored for HIPAA compliance. Only access information necessary for
        payment processing. Unauthorized access or disclosure may result in
        civil and criminal penalties under HIPAA.
      </small>
    </div>
  );
};

export default PHIWarningBanner;
